// eslint-disable-next-line no-restricted-imports, no-restricted-syntax
import { initObservability, useObservability } from '@opendoor/observability';

import type { EventWrapper as ReceptionJourneyEventWrapper } from 'src/__generated__/protobuf/journey/data/event_wrapper';
import { EventWrapper as receptionJourneyEventHelpers } from 'src/__generated__/protobuf/journey/data/event_wrapper';

import { DATADOG_RUM_APPLICATION_CLIENT_TOKEN, DATADOG_RUM_APPLICATION_ID } from './globals';

const SENTRY_DSN = 'https://afc1da46c22d4c72b8cc5f5551fd6cb8@sentry.io/1232559';
const allowUrls: Array<string | RegExp> = [/google/, /simplersell\.com/, /opendoor\.com/];

export type ReceptionTrackingCategory = 'reception-fe';
const loadObservability = () => {
  initObservability<ReceptionTrackingCategory, undefined, ReceptionJourneyEventWrapper>({
    eventTrackingCategory: 'reception-fe',
    appName: 'reception-fe',
    version: process.env.REACT_APP_GIT_SHA || 'unknown',
    sentry: {
      dsn: SENTRY_DSN,
      allowUrls,
    },
    datadog: {
      service: 'reception-fe',
      applicationId: DATADOG_RUM_APPLICATION_ID,
      clientToken: DATADOG_RUM_APPLICATION_CLIENT_TOKEN,
      sampleRate: 100,
      trackInteractions: true,
      trackSessionAcrossSubdomains: true,
      // Please be careful when adding tracing origins.
      // If a server is not prepared for the new Datadog headers, then it may fail with CORS errors.
      // Relevant postmortem: https://docs.google.com/document/d/1O9eWUdXZJOS4Oha2v_dtPfjO34IU3KEDpNqjk3AtXdk/edit
      allowedTracingOrigins: [
        'https://consumer.opendoor.com',
        'https://consumer.managed.services.opendoor.com',
        'https://consumer.simplersell.com',
        'https://consumer-staging.managed.services.opendoor.com',
      ],
    },
    journeyEventHelpers: { toJSON: receptionJourneyEventHelpers.toJSON },
    journeyEndpoint: '/_journey/api/v1',
  });
};

const useObservabilityReception = () =>
  useObservability<ReceptionTrackingCategory, undefined, ReceptionJourneyEventWrapper>();

export { loadObservability, useObservabilityReception as useObservability };
